<div class="card p-4 d-flex flex-column mt-2">
    <nz-skeleton *ngIf="loading" [nzLoading]="loading" [nzActive]="true"></nz-skeleton>

    <div *ngIf="!loading" class="d-flex">
        <div class="d-flex align-items-center">
            <Button class="btn" (click)="back()">
                <img src="https://storage.googleapis.com/komerce/assets/icons/back.svg" alt="" width="40px" />
            </Button>
            <span class="text-black" style="font-size: 20px; font-weight: 600; margin-left: 8px">Detail</span>
        </div>
    </div>
    <div class="d-flex flex-column flex-md-row mt-4 gap-2" *ngIf="!loading && dataWebhook">
        <div class="d-flex flex-column col-12 col-md-6 gap-2">
            <nz-card class="p-4" nzHoverable>
                <div class="d-flex justify-content-between align-items-center">
                    <span class="text-black fw-semibold fs-6">Webhook Information</span>
                    <button class="btn btn-primary text-white py-0 px-1"
                        style="width: fit-content;height: fit-content !important;"
                        (click)="onResend(dataWebhook)">Resend</button>
                </div>
                <div class="d-flex flex-column mt-4">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="text-muted">Status</span>
                        <span [ngClass]="getStatusClass(dataWebhook.status)">{{
                            getStatusValue(dataWebhook.status) }}</span>
                    </div>
                    <hr>
                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <span class="text-muted">Date</span>
                        <span class="text-black">{{ dataWebhook.created_at | date: 'dd MMM yyyy, HH.mm a' }}
                            <span class="text-muted">({{ (dataWebhook.created_at | date: 'z') }})</span> </span>
                    </div>
                    <hr>
                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <span class="text-muted">Payment ID</span>
                        <span class="text-black">{{ dataWebhook.payment_id || 'N/A' }}</span>
                    </div>
                    <hr>
                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <span class="text-muted">Transaction Type</span>
                        <span class="text-black">{{ getPaymentValue(dataWebhook.transaction_type) || 'N/A' }}</span>
                    </div>
                </div>
            </nz-card>
            <nz-card class="p-4" nzHoverable>
                <span class="text-black fw-semibold fs-6">Request Payload</span>
                <div class="mt-3 position-relative markdown-container">
                    <div class="d-flex justify-content-between align-items-center" style="background-color: #C2C2C2;">
                        <span class="text-white" style="background-color: #828282; padding: 2px 8px;">JSON</span>
                        <button (click)="onCopyToClipboard(dataWebhook.payload)" class="btn text-white py-0 px-2"
                            title="Copy to clipboard" style="font-size: 12px;">
                            <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/copy.svg"
                                alt="Copy" width="16" height="16">
                            Copy
                        </button>
                    </div>
                    <markdown [data]="requestPayload" lineNumbers>
                    </markdown>
                </div>
            </nz-card>
        </div>
        <div class="col-12 col-md-6">
            <nz-card class="p-4" nzHoverable>
                <span class="text-black fw-semibold fs-6">Event History</span>

                <div class="d-flex flex-column mt-4">
                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <span class="text-muted">Status</span>
                        <span [ngClass]="getStatusClass(dataWebhook.status)">{{
                            getStatusValue(dataWebhook.status) }}</span>
                    </div>
                    <hr>
                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <span class="text-muted">Time Stamp</span>
                        <span class="text-black">{{ dataWebhook.updated_at | date: 'dd MMM yyyy, HH.mm a' }}
                            <span class="text-muted">({{ (dataWebhook.updated_at | date: 'z') }})</span> </span>
                    </div>
                    <hr>
                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <span class="text-muted">Sender</span>
                        <span class="text-black">{{ dataWebhook.customer_name || 'N/A' }}</span>
                    </div>
                    <hr>
                    <div class="d-flex flex-column flex-md-row justify-content-between">
                        <span class="text-muted">URL</span>
                        <span class="text-black text-wrap text-md-end">{{ dataWebhook.callback_url || 'N/A' }}</span>
                    </div>
                    <div class="mt-4">
                        <nz-collapse nzGhost>
                            <nz-collapse-panel [nzHeader]="headerTemplate" [nzActive]="isResponsePanelActive"
                                [nzDisabled]="false" (nzActiveChange)="isResponsePanelActive = $event">
                                <ng-template #headerTemplate>
                                    <span class="collapse-header-blue fw-semibold">
                                        {{ isResponsePanelActive ? 'Hide Response Payload' : 'Show Response Payload' }}
                                    </span>
                                </ng-template>
                                <div class="position-relative markdown-container-response">
                                    <div class="d-flex flex-column justify-content-between py-3 px-2"
                                        style="background-color: #f8f8f8; border: 1px solid #E2E2E2;">
                                        <div class="d-flex gap-2 align-items-center">
                                            <span [ngClass]="getStatusClass(dataWebhook.status)">{{
                                                dataWebhook.status_code }}</span>
                                            <span>{{
                                                getStatusValue(dataWebhook.status) }}</span>
                                        </div>
                                        <div class="text-muted mt-1">Response Time <strong class="text-black">{{
                                                dataWebhook.response_time_ms || 0 }}
                                                ms</strong></div>
                                    </div>
                                    <markdown [data]="responsePayload" lineNumbers>
                                    </markdown>
                                </div>
                            </nz-collapse-panel>
                        </nz-collapse>
                    </div>
                </div>
            </nz-card>
        </div>
    </div>
</div>